/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StudentResumeeExamsTabViewModel } from "../types/StudentResumeeExamsTabViewModel.ts";
import { studentResumeeExamViewModelSchema } from "./studentResumeeExamViewModelSchema.ts";

export const studentResumeeExamsTabViewModelSchema = z.object({
  fullName: z.string().nullish(),
  gradeEditable: z.optional(z.boolean()),
  companyId: z.number().int().nullish(),
  companyProfile: z.string().nullish(),
  companyUnit: z.string().nullish(),
  companyStartDate: z.string().datetime().nullish(),
  companyEndDate: z.string().datetime().nullish(),
  creationDate: z.string().datetime().nullish(),
  lastChangeDate: z.string().datetime().nullish(),
  userCreation: z.string().nullish(),
  userLastChange: z.string().nullish(),
  exams: z
    .array(z.lazy(() => studentResumeeExamViewModelSchema))
    .describe("Lista de provas do aluno exibida na aba de provas.")
    .nullish(),
}) as unknown as ToZod<StudentResumeeExamsTabViewModel>;
